export default {
    path: '/abnormal/abnormalMsg',
    name: 'AbnormalMsg',
    component: () => import(/* webpackChunkName: "abnormalMsg" */ '../../views/abnormal/components/abnormalMsg.vue')
}